import BreadcrumbList from './BreadcrumbList';

export default BreadcrumbList;
